import React from "react";
import { Box, Typography, Button, Paper } from "@mui/material";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";

const QuickPay: React.FC = (billAmount , accountNo) => {
  return (
    <Box display="flex" flexDirection="column" alignItems="center" mt={4}>
      
      <Typography
        variant="h6"
        fontWeight="bold"
        color="#0A3D91"
        mb={2}
        sx={{ fontSize: "18px", textAlign: "center" }}
      >
        SLT Bill Quick Pay
      </Typography>

      
      <Paper
        elevation={3}
        sx={{
          width: 380,
          backgroundColor: "#F8FAFF",
          borderRadius: "16px",
          padding: "16px",
          position: "relative",
          overflow: "visible",
        }}
      >
        
        <Typography
          variant="h6"
          fontWeight="bold"
          color="#1E2A4A"
          sx={{ fontSize: "16px" }}
        >
          SLT Bill Quick Pay
        </Typography>

        
        <Box
          bgcolor="#EAF1FF"
          p={2}
          borderRadius={2}
          mt={2}
          display="flex"
          flexDirection="column"
          gap={1}
        >
          <Box display="flex" justifyContent="space-between">
            <Typography fontSize={13} color="gray">
              Account Number
            </Typography>
            <Typography fontSize={13} fontWeight="bold" color="#1E2A4A">
              0002206756
            </Typography>
          </Box>

          <Box display="flex" justifyContent="space-between">
            <Typography fontSize={13} color="gray">
              Contact
            </Typography>
            <Typography fontSize={13} fontWeight="bold" color="#1E2A4A">
              0775515201
            </Typography>
          </Box>

          <Box display="flex" justifyContent="space-between">
            <Typography fontSize={13} color="gray">
              Email
            </Typography>
            <Typography fontSize={13} fontWeight="bold" color="#1E2A4A">
              abc@gmail.com
            </Typography>
          </Box>
        </Box>

       
        <Box
          mt={2}
          borderBottom="1px dashed gray"
          position="relative"
          sx={{
            "&::before, &::after": {
              content: '""',
              width: "24px",
              height: "24px",
              backgroundColor: "#F8FAFF",
              borderRadius: "50%",
              position: "absolute",
              top: "50%",
              transform: "translateY(-50%)",
              zIndex: 3,
            },
            "&::before": { left: "-12px" },
            "&::after": { right: "-12px" },
          }}
        />

        
        <Box
          sx={{
            position: "absolute",
            left: "-12px",
            right: "-12px",
            top: "calc(45% + 45px)", 
            display: "flex",
            justifyContent: "space-between",
            zIndex: 20,
          }}
        >
          <Box
            sx={{
              width: "24px",
              height: "24px",
              backgroundColor: "white",
              borderRadius: "50%",
            }}
          />
          <Box
            sx={{
              width: "24px",
              height: "24px",
              backgroundColor: "white",
              borderRadius: "50%",
            }}
          />
        </Box>

        
        <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
          <Box>
            <Typography fontSize={14} color="gray">
              Total Amount
            </Typography>
            <Typography variant="h5" fontWeight="bold" color="#1E2A4A">
              Rs 305,000.<span style={{ fontSize: "16px" }}>00</span>
            </Typography>
          </Box>
          <InsertDriveFileIcon fontSize="large" sx={{ color: "#A0AEC0" }} />
        </Box>
      </Paper>

      
      <Button
        variant="contained"
        sx={{
          backgroundColor: "#4CAF50",
          color: "white",
          mt: 3,
          px: 4,
          borderRadius: "30px",
          fontWeight: "bold",
          textTransform: "none",
          fontSize: "16px",
          height: "45px",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
          minWidth: "180px",
        }}
      >
        Pay Now
      </Button>
    </Box>
  );
};

export default QuickPay;
